"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classnames_1 = __importDefault(require("classnames"));

var dates = __importStar(require("date-fns"));

var react_1 = __importDefault(require("react"));

var DayPickerInput_1 = __importDefault(require("react-day-picker/DayPickerInput"));

var LocaleProvider_1 = __importDefault(require("../LocaleProvider"));

var DateIntervalInputPicker =
/** @class */
function (_super) {
  __extends(DateIntervalInputPicker, _super);

  function DateIntervalInputPicker(props) {
    var _this = _super.call(this, props) || this;

    _this.from = null;
    _this.to = null;

    _this.parseDate = function (str, format) {
      // Remove leading zeros
      var parsed = dates.parse(str.replace(/\.\s*0*/g, '.').replace(/\-\s*0*/g, '-'), format.replace(/\s*/g, ''), new Date());

      if (_this.isDate(parsed)) {
        return parsed;
      }

      return undefined;
    };

    _this.formatDate = function (date, format) {
      return dates.format(date, format);
    };

    _this.handleFromChange = function (from) {
      _this.setState({
        from: from
      });
    };

    _this.handleToChange = function (to) {
      _this.setState({
        to: to
      }, _this.showFromMonth);

      _this.props.onChange({
        from: _this.state.from,
        to: to
      });
    };

    _this.handleYearMonthChangeFromDate = function (month) {
      var newState = {
        month: month,
        from: month
      };

      if (_this.state.to !== undefined && _this.state.to.getTime() < month.getTime()) {
        newState.to = dates.endOfMonth(month);
      }

      _this.setState(newState);

      _this.focusFromInput();
    };

    _this.handleYearMonthChangeToDate = function (month) {
      var newState = {
        month: month,
        to: month
      };

      if (_this.state.from !== undefined && _this.state.from.getTime() > month.getTime()) {
        newState.from = month;
      }

      _this.setState(newState);

      _this.focusToInput();
    };

    _this.focusFromInput = function () {
      _this.from.getInput().focus();
    };

    _this.focusToInput = function () {
      _this.to.getInput().focus();
    };

    _this.inputToHide = function () {
      // need to evaluate onChange if TO date is not changed but FROM date is.
      if (_this.state.from !== _this.props.from) {
        _this.props.onChange({
          from: _this.state.from,
          to: _this.state.to
        });
      }
    };

    var from = props.from,
        to = props.to,
        fromMonth = props.fromMonth;
    _this.state = {
      from: from ? from : undefined,
      to: to ? to : undefined,
      month: fromMonth ? fromMonth : new Date()
    };
    return _this;
  }

  DateIntervalInputPicker.getDerivedStateFromProps = function (nextProps, state) {
    var stateChange = {};

    if (state.from !== nextProps.from && state.prevPropsFrom !== nextProps.from) {
      stateChange.from = nextProps.from;
    }

    if (state.to !== nextProps.to && state.prevPropsTo !== nextProps.to) {
      stateChange.to = nextProps.to;
    }

    stateChange.prevPropsFrom = nextProps.from;
    stateChange.prevPropsTo = nextProps.to;
    return stateChange;
  };

  DateIntervalInputPicker.prototype.isDate = function (value) {
    return value instanceof Date && !isNaN(value.valueOf());
  };

  DateIntervalInputPicker.prototype.showFromMonth = function () {
    var _a = this.state,
        from = _a.from,
        to = _a.to;

    if (!from || !to) {
      return;
    }

    if (dates.differenceInMonths(to, from) < 2) {
      this.to.getDayPicker().showMonth(from);
    }
  };

  DateIntervalInputPicker.prototype.render = function () {
    var _this = this;

    var _a = this.state,
        from = _a.from,
        to = _a.to,
        month = _a.month;
    var _b = this.props,
        label = _b.label,
        numberOfMonths = _b.numberOfMonths;
    var modifiers = {
      start: from,
      end: to
    };
    var dateFormat = LocaleProvider_1.default.locs.date_picker.format || 'dd/M/y'; // tslint:disable-next-line: max-line-length

    var months = LocaleProvider_1.default.locs.date_picker.strings.months; // tslint:disable-next-line: max-line-length

    var weekdaysShort = LocaleProvider_1.default.locs.date_picker.strings.weekdaysShort; // tslint:disable-next-line: max-line-length

    var weekdaysLong = LocaleProvider_1.default.locs.date_picker.strings.weekdaysLong;
    var cn = classnames_1.default('emankit__dateIntervalInputPicker', "emankit__dateIntervalInputPicker--" + numberOfMonths);
    return react_1.default.createElement("div", {
      className: cn
    }, label && react_1.default.createElement("div", {
      className: "emankit__dateIntervalInputPicker__label"
    }, react_1.default.createElement("label", null, label)), react_1.default.createElement("div", {
      className: "row"
    }, react_1.default.createElement("div", {
      className: "emankit__dateIntervalInputPicker__from col-6"
    }, react_1.default.createElement(DayPickerInput_1.default, {
      ref: function ref(el) {
        return _this.from = el;
      },
      value: from,
      placeholder: LocaleProvider_1.default.locs.date_picker.strings.fromDate,
      format: dateFormat,
      formatDate: this.formatDate,
      parseDate: this.parseDate,
      inputProps: {
        className: 'emankit__input emankit__input--grey'
      },
      onDayPickerHide: this.focusToInput,
      keepFocus: false,
      dayPickerProps: {
        onMonthChange: this.focusFromInput,
        selectedDays: from && to ? [from, {
          from: from,
          to: to
        }] : undefined,
        disabledDays: to ? {
          after: to
        } : undefined,
        toMonth: to,
        modifiers: modifiers,
        numberOfMonths: numberOfMonths,
        pagedNavigation: true,
        months: months,
        weekdaysShort: weekdaysShort,
        weekdaysLong: weekdaysLong,
        month: month
      },
      onDayChange: this.handleFromChange
    })), react_1.default.createElement("div", {
      className: "emankit__dateIntervalInputPicker__to col-6"
    }, react_1.default.createElement(DayPickerInput_1.default, {
      ref: function ref(el) {
        return _this.to = el;
      },
      value: to,
      placeholder: LocaleProvider_1.default.locs.date_picker.strings.toDate,
      format: dateFormat,
      formatDate: this.formatDate,
      parseDate: this.parseDate,
      inputProps: {
        className: 'emankit__input emankit__input--grey'
      },
      onDayPickerHide: this.inputToHide,
      keepFocus: false,
      dayPickerProps: {
        onMonthChange: this.focusToInput,
        selectedDays: from && to ? [from, {
          from: from,
          to: to
        }] : undefined,
        disabledDays: from ? {
          before: from
        } : undefined,
        modifiers: modifiers,
        month: month,
        fromMonth: from,
        numberOfMonths: numberOfMonths,
        pagedNavigation: true,
        months: months,
        weekdaysShort: weekdaysShort,
        weekdaysLong: weekdaysLong
      },
      onDayChange: this.handleToChange
    }))));
  };

  DateIntervalInputPicker.defaultProps = {
    numberOfMonths: 2
  };
  return DateIntervalInputPicker;
}(react_1.default.Component);

exports.default = DateIntervalInputPicker;